import React, { Component } from 'react';

import './StartDateToolTip.scss';

import { isRecurringContribute } from '../../utils/transactions-util';
import { trainCase } from '../../utils/utils';

class StartDateToolTip extends Component {
  render() {
    const planWord = isRecurringContribute() ? 'contribution' : 'transaction';
    return (
      <div>
        <div className="start-date-tool-tip-title">
          Important Information Regarding the Scheduled Dates of your Automatic{' '}
          {trainCase(planWord)}
        </div>
        <div className="start-date-tool-tip-content">
          By selecting this service, you acknowledge that automatic {planWord}s
          will be placed in accordance with the following:
        </div>
        <div className="start-date-tool-tip-content">
          Automatic{' '}
          {isRecurringContribute() ? 'Contributions' : 'Transaction programs'}{' '}
          are typically established the following business day, but can take up
          to three business days to be completed. Choosing a start date that
          falls within three business days of today’s date may cause your first{' '}
          {planWord} to occur at the next scheduled{' '}
          {isRecurringContribute() ? 'date' : 'automatic transaction'}.
        </div>
        <div className="start-date-tool-tip-content">
          Except for certain dates as noted below, if one of your chosen dates
          occurs on a weekend or holiday, the{' '}
          {isRecurringContribute() ? 'contribution' : 'trade'} will be{' '}
          {isRecurringContribute() ? 'processed' : 'placed'} on the next
          business day at that business day’s Net Asset Value (NAV).
        </div>
        <div className="start-date-tool-tip-content" id="last-content">
          <span className="start-date-tool-tip-emphasis">Exception:</span> If
          your chosen date falls either on a day that does not exist on the
          calendar (ex. February 31st) or on the last weekend of the year and
          the next business day is the following year, your{' '}
          {isRecurringContribute() ? 'contribution ' : 'trade '}
          will be {isRecurringContribute() ? 'processed' : 'placed'} on the
          previous business day at that business day’s NAV.
        </div>
      </div>
    );
  }
}

export default StartDateToolTip;
